import { render } from "./DashboardFilters.vue?vue&type=template&id=781df812&scoped=true"
import script from "./DashboardFilters.vue?vue&type=script&lang=ts"
export * from "./DashboardFilters.vue?vue&type=script&lang=ts"

import "./DashboardFilters.vue?vue&type=style&index=0&id=781df812&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-781df812"

export default script